import {
  StyledNoDataCard,
  StyledNoDataLabel,
  StyledNoDataContainer,
  StyledNoDataText,
} from "../../pages/selller/dashboards/styles";

interface NoDataFoundProps {
  title: string;
  message?: string;
  CardComponent?: React.ComponentType<{ children: React.ReactNode }>;
  CardLabelComponent?: React.ComponentType<{ children: React.ReactNode }>;
  CardContentComponent?: React.ComponentType<{ children: React.ReactNode }>;
}

export default function NoDataFound({
  title,
  message = "No data available for the selected period",
  CardComponent,
  CardLabelComponent,
  CardContentComponent,
}: NoDataFoundProps) {
  const DefaultCard = ({ children }: { children: React.ReactNode }) => (
    <StyledNoDataCard>{children}</StyledNoDataCard>
  );

  const DefaultLabel = ({ children }: { children: React.ReactNode }) => (
    <StyledNoDataLabel variant="h6">{children}</StyledNoDataLabel>
  );

  const DefaultContent = ({ children }: { children: React.ReactNode }) => (
    <div>{children}</div>
  );

  const Card = CardComponent || DefaultCard;
  const Label = CardLabelComponent || DefaultLabel;
  const Content = CardContentComponent || DefaultContent;

  return (
    <Card>
      <Label>{title}</Label>
      <Content>
        <StyledNoDataContainer>
          <StyledNoDataText variant="body1">{message}</StyledNoDataText>
        </StyledNoDataContainer>
      </Content>
    </Card>
  );
}
